// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page-template {
  width: 100%;
  height: 100%;
  background-color: var(--mi-background-color) !important;
}
.profile-page-template.desktop {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: min-content auto;
}
.profile-page-template.desktop app-header {
  grid-row: 1;
  grid-column: 1;
}
.profile-page-template.desktop app-three-column-layout {
  grid-row: 2;
  grid-column: 1;
}
.profile-page-template app-three-column-layout .profile-info-container, .profile-page-template app-three-column-layout .about-me-container-desktop {
  margin: 10px;
}
.profile-page-template app-three-column-layout .container {
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: min-content 1fr auto;
}
.profile-page-template app-three-column-layout .container app-top-bar {
  --top-bar-column-gap: 18.5px;
  grid-row: 1;
  grid-column: 1;
}

app-profile-settings-get-verified-card::ng-deep .first-card {
  height: unset;
}
app-profile-settings-get-verified-card::ng-deep .buttons-container {
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
}
app-profile-settings-get-verified-card::ng-deep .buttons-container .button {
  width: unset !important;
  margin: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
